<template>
  <div>
    <b-card class="standardpage border-none">
      <b-card-header>
        <b-row>
          <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
            <i :class="salesgroups.icon" class="mr-1"></i>
            <span>{{ salesgroups.title }}</span>
          </b-col>
        </b-row>
      </b-card-header>

      <div v-show="!component" class="availtable datatable">
        <b-card class="w-100pct mb-2">
          <b-card-body class="py-0">

            <b-row v-if="!showfilter">
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Name" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="id" :debounce="salesgroups.debounce" placeholder="Name"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!id" @click="id = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Type" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="type" :debounce="salesgroups.debounce" placeholder="Type"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!type" @click="type = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Active?" label-for="isenabled" label-cols="12">
                  <treeselect instanceId="isenabled" type="number" v-model="isenabled" :clearable="true"
                    :options="isenabled_options"></treeselect>
                </b-form-group>
              </b-col>
              <!-- <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Enabled" label-for="enabled" label-cols="12">
                  <b-input-group class="z-0">
                    <b-form-radio-group id="enabled" v-model="isenabled" :options="[
                      { text: 'Enabled', value: true },
                      { text: 'Disabled', value: false },
                    ]" buttons button-variant="outline-success" size="sm"
                      name="radio-btn-outline"></b-form-radio-group>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!isenabled" @click="isenabled = null">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col> -->
            </b-row>
          </b-card-body>
        </b-card>
        <div class="px-3">
          <d-table classdivtable="availtable datatable" refid="salesgroups" :icon="salesgroups.icon"
            :busy="salesgroups.busy" :toolbarlibrary="salesgroups.toolbarlibrary" :tools="salesgroups.tools"
            :badges="salesgroups.badges" :fields="salesgroups.fields" :items="salesgroups.items"
            :limit="salesgroups.limit" :downloaded="salesgroups.downloaded" :showpages="true"
            :offset="salesgroups.offset" :page="salesgroups.page" @load="salesgroups_load" @click="salesgroups_click"
            @changed="salesgroups_click('save', $event)" @select="salesgroups_select">
          </d-table>
        </div>
      </div>

      <div v-show="component">
        <component :is="component" :selection="salesgroups.selected" :config="cconfig"
          @discard="salesgroups_click('discard')" @go="salesgroups_click('go')"></component>
      </div>
      <b-card-footer class="mt-2 ml-1">
        <div class="text-center">
          <b-button squared size="sm" variant="outline-primary" @click="$emit('discard')">
            <i class="fa fa-cogs mr-2"></i>Setup All
          </b-button>
        </div>
      </b-card-footer>

    </b-card>
  </div>
</template>


<script>
import gql from "graphql-tag";

import SalesGroupsEdit from "./Components/Setup_SalesGroupsEdit";

export default {
  name: "SalesGroups",
  components: { SalesGroupsEdit },
  watch: {
    async id() {
      await this.salesgroups_load(0);
    },
    async type() {
      await this.salesgroups_load(0);
    },
    async isenabled() {
      await this.salesgroups_load(0);
    },
  },
  data() {
    return {
      id: null,
      type: null,
      isenabled: true,
      isenabled_options: [
        {
          id: true,
          label: "Yes",
        },
        {
          id: false,
          label: "No",
        },
      ],
      salesgroups: {
        title: "Sales Groups",
        icon: "fa fa-building",
        debounce: 500,
        busy: false,
        page: 1,
        offset: 0,
        limit: 15,
        tools: "go,filter,download,add,edit,deleteconfirm",
        toolbarlibrary: [],
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-center w-35px",
          },
          {
            key: "id",
            label: "Name",
            sortable: true,
          },
          {
            key: "type",
            label: "Type",
            sortable: true,
          },
          {
            key: "manager",
            label: "Manager",
            sortable: true,
          },
          {
            key: "enabled",
            label: "Active",
            sortable: true,
          },
          {
            key: "updated_by",
            label: "Updated By",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "updated_at",
            label: "Updated At",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px",
          },
        ],
        badges: [
          {
            key: "enabled",
            type: "badge",
            Yes: "success",
            No: "danger",
            formatter: (value, key, item) => {
              if (value == false) {
                return "No";
              } else if (value == true) {
                return "Yes";
              } else {
                return "";
              }
            },
          },
        ],
        items: [],
        selected: [],
        downloaded: [],
        denied: [],
      },
    };
  },
  async mounted() {
    this.accessdenied();
    await this.salesgroups_load();
  },

  methods: {
    accessdenied() {
      this.salesgroups.denied = [];
      if (!this.user.permissions.includes("setup_salesgroups.admin")) {
        this.salesgroups.denied.push("deleteconfirm");
      }
      if (!this.user.permissions.includes("setup_salesgroups.admin")) {
        this.salesgroups.denied.push("add");
        this.salesgroups.denied.push("save");
      }
    },

    async salesgroups_load(offset, limit, page) {
      let state = this.salesgroups;

      if (offset || offset == 0) {
        state.offset = offset
      }
      if (limit || limit == 0) {
        state.limit = limit
      }
      if (page) {
        state.page = page
      }

      state.busy = true;

      let variables = {
        offset: state.offset,
        limit: state.limit,

        id: this.id,
        type: this.type,
        manager: this.manager,
        isenabled: this.isenabled,
        dateformat: "DD/MM/YYYY"
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
              query salesgroups(
                $limit: Int
                $offset: Int
                $id: String
                $type: String
                $manager: String
                $isenabled: Boolean        
                $dateformat: String                
              ) {
                  salesgroups(
                  limit: $limit
                  offset: $offset
                  id: $id
                  type: $type
                  manager: $manager
                  isenabled: $isenabled
                  dateformat: $dateformat
              
                ) {
                                                
                  id
                  type
                  manager
                  enabled                             
                  rows
                  updated_at
                  updated_by
                }
              }
            `,
          variables,
        });

        // USE LOCAL VARIABLE

        state.downloaded = []
        if (limit == 0) {
          state.downloaded = response.data.salesgroups
        } else {
          state.items = response.data.salesgroups;
        }

      } catch (error) {
        console.log(error);
      }

      state.busy = false;
    },
    async salesgroups_click(a, ss) {

      let state = this.salesgroups;

      switch (a) {
        case "download_view":
          state.downloaded = []
          state.downloaded = state.items
          break;

        case "download_all":
          state.downloaded = []
          await this.salesgroups_load(0, 0);
          break;
        case "filter":
          this.showfilter = !this.showfilter;
          break;
        case "discard":
          this.component = null;
          break;
        case "go":
          this.component = null;
          this.salesgroups_load();
          break;
        case "add":
        case "edit":
          this.component = "SalesGroupsEdit";
          break;

        case "save":
          this.saveit(ss);
          break;

        case "delete":
          this.deleteit(ss);
          break;
      }
    },
    async salesgroups_select(ss, tools) {

      let state = this.salesgroups;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "go", "filter", "add", "download"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        enabled = ["edit"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        enabled = ["deleteconfirm"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 ? false : true;
          }
        });

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }
    },

    async saveit(ss) {

      this.busy = true;

      let variables = { rows: this.cleanit(ss) };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
              mutation salesgroups_save(
                $rows: [Salesgroup_input]             
              ) {
                salesgroups_save(rows: $rows) {
                  id
                type
                manager
                enabled        
                    
                }
              }
            `,
          variables,
        });
        console.log(response);
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },
    async deleteit(ss) {

      let rows = [];
      ss.forEach(function (v) {
        rows.push({ id: v.id });
      });

      let variables = {
        rows,
      };

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
              mutation salesgroups_delete(
                $rows: [Salesgroup_input]
              ) {
                salesgroups_delete(rows: $rows) {
                  id
                }
              }
            `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }

      await this.salesgroups_load(0);
    },
  },
};
</script>

<style></style>